import {
    aeWorkspaceElementsPanelMargin,
    smmWorkspaceElementsPanelMargin,
} from 'pages/components/constants'

type TitleThresholds = Record<
    number,
    { productType: number; default: number | null }
>

// OM has a shallower tree (levels 0–1) with lower char thresholds; SMM goes deeper (levels 0–4) with higher ones.
const OM_TITLE_THRESHOLDS: TitleThresholds = {
    0: { productType: 20, default: 25 },
    1: { productType: 20, default: null },
}

const TITLE_THRESHOLDS: TitleThresholds = {
    0: { productType: 46, default: 46 },
    1: { productType: 40, default: 40 },
    2: { productType: 20, default: 30 },
    3: { productType: 20, default: 25 },
    4: { productType: 20, default: null },
}

export const showElementCardTitleInSingleLine = (
    title: string,
    nestingLevel?: number,
    elementType?: string,
    isOMWorkspace?: boolean
): boolean => {
    if (nestingLevel === undefined) return false
    const thresholds = isOMWorkspace ? OM_TITLE_THRESHOLDS : TITLE_THRESHOLDS
    const config = thresholds[nestingLevel]
    if (!config) return false
    const threshold =
        elementType === 'PRODUCTTYPE' ? config.productType : config.default
    return threshold !== null && title.length >= threshold
}

export const elementsPanelSearchBarMargin = (
    isOMWorkspace?: boolean,
    isSMMWorkspace?: boolean
): number => {
    return isSMMWorkspace || isOMWorkspace
        ? smmWorkspaceElementsPanelMargin
        : aeWorkspaceElementsPanelMargin
}
